export function formatDateTime(isoDateTime, dateType = "datetime") {
    let options = { timeZone: 'UTC' };
    switch (dateType) {
        case "date":
            options = {
                timeZone: 'UTC',
                year: 'numeric',
                month: 'short',
                day: 'numeric'
            };
            break;
        case "datetime":
            options = {
                timeZone: 'UTC',
                year: 'numeric',
                month: 'short',
                day: 'numeric',
                hour: '2-digit',
                minute: '2-digit',
                second: '2-digit',
            };
            break;
        case "time":
            options = {
                timeZone: 'UTC',
                hour: '2-digit',
                minute: '2-digit',
                second: '2-digit',
            };
    }
    return new Date(isoDateTime).toLocaleString(undefined, options);
}
